import { Button } from '../../styles/GlobalComponents';
import { Box, Flexed } from '../../styles/GlobalComponents';
import { Icon, IconApproveNFTFail } from '../../styles/Icons';
import { P2 } from '../../styles/FontStyles';

export const Failed = ({ setIsSideModalOpen }: { setIsSideModalOpen: any }) => {
  return (
    <>
      <Box gray>
        <Flexed column center>
          <Flexed>
            <Icon mb='20'>
              <IconApproveNFTFail />
            </Icon>
          </Flexed>
        </Flexed>

        <P2 bold center mb='20'>
          Unfortunately, your payment could not be processed. Please try again .
        </P2>

        <Flexed column center>
          <Button w='200px' negative onClick={() => setIsSideModalOpen(false)}>
            Close
          </Button>
        </Flexed>
      </Box>
    </>
  );
};
